module.exports = __webpack_public_path__ + "img/restaurant.2d7b14df.jpg";